import { z } from 'zod';

export const LoginSchema = z.object({
  username: z.string(),
  password: z.string(),
});

export const BaseModelSchema = z.object({
  id: z.string(),
  createdBy: z.string(),
  updatedBy: z.string(),
  timeCreated: z.string(),
  timeUpdated: z.string(),
  code: z.string().min(1),
  description: z.string().min(1),
  active: z.boolean().default(true),
});

export const WarehouseSchema = z.object({
  id: z.string(),
  createdBy: z.string(),
  updatedBy: z.string(),
  timeCreated: z.string(),
  timeUpdated: z.string(),
  code: z.string().min(1),
  description: z.string().min(1),
  active: z.boolean().default(true),
  address: z.string(),
  city: z.object({
    id: z.string(),
  }),
  country: z.object({
    id: z.string(),
  }),
});

export const LocationSchema = z.object({
  id: z.string(),
  createdBy: z.string(),
  updatedBy: z.string(),
  timeCreated: z.string(),
  timeUpdated: z.string(),
  code: z.string().min(1),
  description: z.string().min(1),
  active: z.boolean().default(true),
  warehouse: z.object({
    id: z.string(),
  }),
});

export const PartnerSchema = z.object({
  id: z.string(),
  createdBy: z.string(),
  updatedBy: z.string(),
  timeCreated: z.string(),
  timeUpdated: z.string(),
  code: z.string().min(1),
  description: z.string().min(1),
  active: z.boolean().default(true),
  city: z.object({
    id: z.string(),
  }),
  country: z.object({
    id: z.string(),
  }),
  lineOfBusiness: z.object({
    id: z.string(),
  }),
  postalCode: z.string(),
  email: z.string(),
  phoneNo: z.string(),
  faxNo: z.string(),
  website: z.string(),
  agentName: z.string(),
  agentContact: z.string(),
  contactFinance: z.string(),
  contactPerson: z.string(),
  contactShipping: z.string(),
  notes: z.string(),
});
